/*
 * NIF ou número de IVA no carrinho (sections/main-cart-footer.liquid).
 *
 * Aceita duas formas, depois de tirar espaços, pontos e hífens e pôr em maiúsculas:
 *  - NIF português: 9 dígitos com o dígito de controlo certo (módulo 11), com ou sem "PT" à frente;
 *  - número de IVA com código de país: duas letras e 2 a 13 caracteres alfanuméricos (ESB12345678,
 *    DE123456789, IE1234567WA, NL123456789B01, CHE123456789...). Não se valida o formato de cada país,
 *    só a estrutura; a fatura é emitida à mão pelo dono, que confirma.
 *
 * O valor grava-se no carrinho ao sair do campo (/cart/update.js), para sobreviver a idas e voltas, e
 * segue de qualquer maneira com o botão "Finalizar a compra", que submete o formulário #cart. Um valor
 * inválido bloqueia esse botão e mostra a mensagem; vazio é válido, porque o campo é opcional.
 */
class CartNif extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.erro = this.querySelector('.cart__nif-error');
    this.botao = document.getElementById('checkout');
    this.input.addEventListener('input', () => this.mostrar(true));
    this.input.addEventListener('change', () => this.guardar());
    if (this.botao) this.botao.addEventListener('click', (e) => { if (!this.mostrar(false)) { e.preventDefault(); this.input.focus(); } });
  }

  static limpar(v) {
    return (v || '').toUpperCase().replace(/[\s.\-]/g, '');
  }

  static nifPt(v) {
    if (!/^\d{9}$/.test(v)) return false;
    const d = v.split('').map(Number);
    let soma = 0;
    for (let i = 0; i < 8; i++) soma += d[i] * (9 - i);
    const resto = soma % 11;
    return d[8] === (resto < 2 ? 0 : 11 - resto);
  }

  static valido(bruto) {
    const v = CartNif.limpar(bruto);
    if (v === '') return true;
    if (/^(PT)?\d{9}$/.test(v)) return CartNif.nifPt(v.replace(/^PT/, ''));
    return /^[A-Z]{2}[0-9A-Z]{2,13}$/.test(v);
  }

  mostrar(sóSeJáErrado) {
    const ok = CartNif.valido(this.input.value);
    if (ok) {
      this.erro.hidden = true;
      this.input.removeAttribute('aria-invalid');
    } else if (!sóSeJáErrado || !this.erro.hidden) {
      this.erro.hidden = false;
      this.input.setAttribute('aria-invalid', 'true');
    }
    return ok;
  }

  guardar() {
    const v = CartNif.limpar(this.input.value);
    this.input.value = v;
    if (!this.mostrar(false)) return;
    fetch(`${routes.cart_update_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'NIF / VAT': v } }),
    }).catch(() => {});
  }
}

customElements.define('cart-nif', CartNif);
